import { render, staticRenderFns } from "./optifySelect.vue?vue&type=template&id=a82a5520"
import script from "./optifySelect.vue?vue&type=script&lang=js"
export * from "./optifySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports